// extracted by mini-css-extract-plugin
export default {"container":"login_container__nlmrK","form":"login_form__c7T27","actions":"login_actions__EZxk8","actions__link":"login_actions__link__quB6m"};